import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("b", null, "Veuillez compléter ces champs :", -1)
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "form-group w-50" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "title" }, "Titre", -1)
const _hoisted_7 = { class: "form-group w-50" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "realisateur" }, "Réalisateur", -1)
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { for: "year" }, "Année de sortie", -1)
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { for: "imgUrl" }, "Affiche", -1)
const _hoisted_13 = { class: "d-flex col-4 justify-content-around" }
const _hoisted_14 = { class: "col-6" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "col-6" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "btn btn-primary my-3 col-10"
  }, " Modifier ")
], -1)
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-primary" }, " Retour à l'accueil ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.checkForm && _ctx.checkForm(...args))),
      class: "mx-auto d-flex flex-column align-items-center"
    }, [
      (_ctx.errors.length)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: error.id
                }, _toDisplayString(error), 1))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.title) = $event)),
            type: "text",
            class: "form-control",
            id: "inputTitle"
          }, null, 512), [
            [_vModelText, _ctx.title]
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.director) = $event)),
            type: "string",
            class: "form-control",
            id: "inputRealisateur"
          }, null, 512), [
            [_vModelText, _ctx.director]
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.year) = $event)),
            type: "number",
            class: "form-control",
            id: "inputYear",
            min: "1000",
            max: "9999"
          }, null, 512), [
            [_vModelText, _ctx.year]
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.posterUrl) = $event)),
            type: "string",
            class: "form-control",
            id: "inputImgUrl"
          }, null, 512), [
            [_vModelText, _ctx.posterUrl]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("button", {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.deleteMovie(this.$route.params.id))),
            class: "btn btn-danger my-3"
          }, " Supprimer ")
        ]),
        _hoisted_15
      ])
    ], 32),
    (_ctx.submitted)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          (_ctx.updated)
            ? (_openBlock(), _createElementBlock("h4", _hoisted_17, "Votre film a bien été modifié !"))
            : _createCommentVNode("", true),
          (_ctx.deleted)
            ? (_openBlock(), _createElementBlock("h4", _hoisted_18, "Votre film a bien été supprimé, redirection vers la page d'accueil automatique dans 2 secondes !"))
            : _createCommentVNode("", true),
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [
              _hoisted_19
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}